import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { styles } from '@sdir/sds';
// eslint-disable-next-line max-len
import { HealthServiceCoreFeaturesMedicalExaminationApiModelsMedicalCertificateVerifyDto as HealthDto } from '@sdir/httpclient/lib/clients/aps/health';
import {
  formatDateString,
  formatFullName,
} from '@sdir/blueprint.aps/lib/helpers/formattingHelpers';

type HealthDeclarationProps = {
  data?: HealthDto;
};

const HealthDeclaration: React.FC<HealthDeclarationProps> = ({ data }) => {
  const intl = useIntl();
  return (
    <Wrapper>
      <Row>
        <span>{intl.formatMessage({ id: 'health.practitioner' })}</span>
        <span>
          {formatFullName(
            data?.practitioner?.firstname || '',
            data?.practitioner?.middlename || '',
            data?.practitioner?.lastname || ''
          )}
        </span>
      </Row>
      <Row>
        <span>{intl.formatMessage({ id: 'status' })}</span>
        <span>
          {data
            ? intl.formatMessage({ id: 'status.valid' })
            : intl.formatMessage({ id: 'status.expired' })}
        </span>
      </Row>
      <Row>
        <span>{intl.formatMessage({ id: 'name' })}</span>
        <span>
          {formatFullName(
            data?.seafarer?.firstname || '',
            data?.seafarer?.middlename || '',
            data?.seafarer?.lastname || ''
          )}
        </span>
      </Row>
      <Row>
        <span>{intl.formatMessage({ id: 'expirydate' })}</span>
        <span>{formatDateString(data?.expiryDate || '')}</span>
      </Row>
      <Row>
        <span>{intl.formatMessage({ id: 'birthnumber' })}</span>
        <span>{formatDateString(data?.seafarer?.dateOfBirth || '')}</span>
      </Row>
      <Row>
        <span>{intl.formatMessage({ id: 'health.decisiondate' })}</span>
        <span>{formatDateString(data?.validFrom || '')}</span>
      </Row>
      <Row>
        <span>{intl.formatMessage({ id: 'health.examinationdate' })}</span>
        <span>{formatDateString(data?.examinationDate || '')}</span>
      </Row>
    </Wrapper>
  );
};

export default HealthDeclaration;

const Wrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  box-shadow: ${styles.card.boxShadow};
  background: white;
  padding: 20px;
  max-width: 480px;
`;

const Row = styled.div`
  display: flex;
  &:not(:last-child) {
    margin-bottom: 10px;
  }

  span:first-child {
    min-width: 170px;
    font-weight: 600;
  }
`;
